import React from "react";
import {
  Button as FluentUIButton,
  ButtonProps as FluentUIButtonProps,
} from "@fluentui/react-components";
import useButtonStyles from "./Button.styles";

type ButtonProps = FluentUIButtonProps & {
  label: string;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
};

export const Button: React.FC<ButtonProps> = ({
  label,
  startIcon,
  endIcon,
  appearance = "primary",
  size = "medium",
  disabled,
  ...rest
}) => {
  const styles = useButtonStyles();

  return (
    <FluentUIButton
      appearance={appearance}
      size={size}
      disabled={disabled}
      className={styles.root}
      {...rest}
    >
      <span className={styles.contentWrapper}>
        {startIcon && startIcon}
        <span>{label}</span>
        {endIcon && endIcon}
      </span>
    </FluentUIButton>
  );
};
